export enum TicketStatusSupportTranslate {
    OPEN = 'openTickets',
    CLOSED = 'closedTickets'
}

export enum TicketStatusSupport {
    OPEN = 'openTickets',
    CLOSED = 'closedTickets'
}

export enum TicketStatusZendesk {
    ALL = 'All',
    OPEN = 'Open',
    SOLVED = 'Solved',
    CLOSED = 'Closed',
    PENDING = 'Pending'
}
